<template>
    <v-text-field 
        @keydown="checkForNumber"
        :value="value[schema.name]" 
        @change="$emit('change', $event)"
        :label="schema.label" 
        :hide-details="false" 
        :hint="schema.hint" 
        :placeholder="schema.placeholder || ' '"
        outlined dense
    />
</template>

<script>

import NumberHelpers from '@/helpers/NumberHelpers'

export default {

    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        value: Object,
        schema: Object, 
    },

    computed: {

    },

    methods: {
        checkForNumber(e) {
            console.log(e)
            if(!NumberHelpers.isNumeric(e.key) && !this.isNavigationKey(e.key)) {
                e.preventDefault()
            }
        },

        isNavigationKey(key) {
            return Boolean(['Tab', 'ArrowRight', 'ArrowLeft', 'Backspace'].indexOf(key) > -1)
        }
    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// NumberControl.vue?3b0cd9da